if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.content = this.querySelector('[role="document"]');
      this.content.tabIndex = -1;
      this.closeButton = this.querySelector('[id^="ModalClose-"]');
      this.navigation = document.createElement('div');
      this.navigation.className = 'product-media-modal__navigation';
      this.navigation.innerHTML = '<button type="button" data-gallery-previous aria-label="Previous media">Previous</button><span role="status" aria-live="polite" aria-atomic="true"></span><button type="button" data-gallery-next aria-label="Next media">Next</button>';
      this.querySelector('[role="dialog"]').appendChild(this.navigation);
      this.navigation.querySelector('[data-gallery-previous]').addEventListener('click', () => this.moveMedia(-1));
      this.navigation.querySelector('[data-gallery-next]').addEventListener('click', () => this.moveMedia(1));
      this.addEventListener('pointerup', (event) => {
        // ModalDialog dismisses images on mouse-up; keep media and gallery controls interactive.
        if (event.target.closest('.product-media-modal__navigation, img[data-media-id]')) event.stopImmediatePropagation();
      }, true);
      this.addEventListener('keydown', this.onGalleryKeydown.bind(this));
      this.keepFocusInside = (event) => {
        if (this.hasAttribute('open') && !this.contains(event.target)) this.closeButton.focus({ preventScroll: true });
      };
    }

    show(opener) {
      this.openedBy = opener;
      this.items = Array.from(this.content.children).filter((item) => item.hasAttribute('data-media-id'));
      if (!this.items.length) return;
      const selectedIndex = this.items.findIndex((item) => item.dataset.mediaId === opener.dataset.mediaId);
      this.showActiveMedia(selectedIndex < 0 ? 0 : selectedIndex);
      super.show(opener);
      // The shared trap includes hidden video controls. Use visible controls in this viewer instead.
      removeTrapFocus();
      document.addEventListener('focusin', this.keepFocusInside);
      this.loadActiveMedia();
      this.closeButton.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      document.removeEventListener('focusin', this.keepFocusInside);
      if (this.hasAttribute('open')) this.hide();
    }

    hide() {
      document.removeEventListener('focusin', this.keepFocusInside);
      super.hide();
    }

    showActiveMedia(index = this.activeIndex || 0) {
      window.pauseAllMedia();
      index = Number.isInteger(index) && index >= 0 && index < this.items.length ? index : 0;
      this.activeIndex = index;
      this.items.forEach((item, itemIndex) => {
        const active = itemIndex === index;
        item.classList.toggle('active', active);
        item.hidden = !active;
        item.inert = !active;
        if (active) item.removeAttribute('aria-hidden');
        else item.setAttribute('aria-hidden', 'true');
      });
      this.content.scrollTop = 0;
      this.content.scrollLeft = 0;
      this.navigation.hidden = this.items.length < 2;
      this.navigation.querySelector('[role="status"]').textContent = `Media ${index + 1} of ${this.items.length}`;
    }

    loadActiveMedia() {
      const activeMedia = this.items[this.activeIndex];
      const template = activeMedia.querySelector('template');
      if (activeMedia.nodeName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) {
        // Keep the theme's YouTube activation behavior without taking focus away from gallery controls.
        activeMedia.loadContent(false);
      }
    }

    moveMedia(direction) {
      this.showActiveMedia((this.activeIndex + direction + this.items.length) % this.items.length);
      this.loadActiveMedia();
    }

    onGalleryKeydown(event) {
      if (!this.hasAttribute('open')) return;
      if (event.key === 'Tab') {
        const controls = Array.from(this.querySelectorAll('button:enabled, a[href], input:enabled, select:enabled, textarea:enabled, iframe, video[controls], [tabindex]:not([tabindex="-1"])'))
          .filter((element) => element.getClientRects().length && !element.closest('[inert]'));
        const first = controls[0] || this.closeButton;
        const last = controls[controls.length - 1] || this.closeButton;
        if (event.shiftKey && (document.activeElement === first || !controls.includes(document.activeElement))) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !controls.includes(document.activeElement))) {
          event.preventDefault();
          first.focus();
        }
        return;
      }
      // Preserve native video, embedded player, model and form keyboard controls.
      if (event.target.closest('video, iframe, model-viewer, input, textarea, select, [contenteditable="true"]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        this.moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
      }
    }
  });
}
